import { useDotLegalSnackbar } from "@dotlegal/dotlegal-ui-components";
import { put } from "../../../common/api/apiShared";
import { EvaluationStatusSaveModel } from "../../../common/components/questionnaireComponents/evaluateQuestionnaireDialog/EvaluateQuestionnaireDialog.types";
import { IEvaluateAuditDialog } from "./EvaluateAuditDialog";
import { createElement } from "react";
import { Trans } from "react-i18next";
import { useDotLegalMutation } from "@common/hooks/dotLegalReactQuery";

export default function useEvaluateAuditDialogHooks(props: IEvaluateAuditDialog) {
    const snackbar = useDotLegalSnackbar();

    const evaluationMutation = useDotLegalMutation(evaluateApi);

    const saveEvaluation = (saveModel: EvaluationStatusSaveModel) => {
        evaluationMutation.mutateAsync(saveModel, {
            onSuccess: (resp: any) => {
                props.onEvaluated();
                snackbar.show(createElement(Trans, { i18nKey: "auditEvaluated", values: { name: props.questionnaireName } }));
            },
        });
    };

    function evaluateApi(saveModel: EvaluationStatusSaveModel) {
        return put<{}>(`/legalEntityAudit/${props.id}/evaluate`, saveModel);
    }

    return {
        saveEvaluation,
        isSaving: evaluationMutation.isLoading,
    };
}
